/*
 * @Author: Teemo Ding
 * @Date: 2022-02-17 15:44:24
 * @LastEditTime: 2022-06-06 10:35:43
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Communication/Detail/CommunicationGateway/Components/Sendgrid.tsx
 */
import { Label } from '@/src/components/Antd';
import Configuration from '@/src/components/Configuration/Configuration';
import Row from '@/src/components/Layouts/Row/Row';
import PasswordInput from '@/src/components/Password';
import { NEW } from '@/src/tools/constant';
import { QuestionCircleFilled } from '@ant-design/icons';
import { Form, InputNumber } from 'antd';
import React, { Fragment } from 'react';
import WhiteBackgroundTooltip, {
  TooltipContainer,
  TooltipContent,
} from 'src/components/GlobalTooltip/WhiteBackgroundTooltip';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { InputWithValue } from '../../../Components/FormComponents';

const Sendgrid = ({
  editable,
  communicationUuid,
  unlockEditable,
  handleResetInput,
  disabled,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <Fragment>
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='apiKeys'
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storeCommunicationSetting.detail.aPIKeys'),
                    ),
                  },
                ]}
                labelCol={{ span: 24 }}
                label={
                  <Label
                    title={`${getI18n(
                      'storeCommunicationSetting.detail.aPIKeys',
                    )}*`}
                  />
                }>
                <InputWithValue edit={editable}>
                  <PasswordInput
                    editable={
                      communicationUuid === NEW ||
                      unlockEditable.includes('apiKeys')
                    }
                    onEdit={() => handleResetInput('apiKeys')}
                    passwordProps={{ maxLength: 100 }}
                    disabled={disabled}
                  />
                </InputWithValue>
              </Form.Item>
            ),
          },
          {
            child: null,
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <Fragment>
                <Form.Item
                  name='unsubscribeGroupId'
                  rules={[
                    {
                      required: true,
                      message: replaceI18nVariables(
                        getI18n('general.fieldisrequired'),
                        getI18n(
                          'storeCommunicationSetting.common.unsubscribeGroupID',
                        ),
                      ),
                    },
                  ]}
                  labelCol={{ span: 24 }}
                  label={
                    <Label
                      title={
                        <span>
                          {`${getI18n(
                            'storeCommunicationSetting.common.unsubscribeGroupID',
                          )}*`}{' '}
                          <WhiteBackgroundTooltip
                            title={
                              <TooltipContainer>
                                <TooltipContent>
                                  {getI18n(
                                    'storeCommunicationSetting.common.promoRequireTagTipsForm',
                                  )}
                                </TooltipContent>
                              </TooltipContainer>
                            }
                            placement='rightTop'>
                            <QuestionCircleFilled rev={undefined} />
                          </WhiteBackgroundTooltip>
                        </span>
                      }
                    />
                  }>
                  <InputWithValue edit={editable}>
                    <InputNumber
                      size='large'
                      disabled={disabled}
                      style={{ width: '100%' }}
                      precision={0}
                      min={0}
                    />
                  </InputWithValue>
                </Form.Item>
                {editable && (
                  <Configuration
                    hideGt
                    configStart={getI18n(
                      'storeCommunicationSetting.common.pleaseGoTo',
                    )}
                    configLink={
                      'Sendgrid Dashboard > Suppressions > Unsubscribe Group'
                    }
                    configEnd={getI18n(
                      'storeCommunicationSetting.common.checkUnsubscribeGroupId',
                    )}
                    href='https://app.sendgrid.com/suppressions/advanced_suppression_manager'
                  />
                )}
              </Fragment>
            ),
          },
          {
            child: null,
          },
        ]}
      />
    </Fragment>
  );
};

export default Sendgrid;
